import ApiService from "@/common/api.service";
import JwtService from "@/common/jwt.service";

// action types
export const VERIFY_AUTH = "verifyAuth";
export const LOGIN = "login";
export const LOGOUT = "logout";
export const REGISTER = "register";
export const UPDATE_USER = "updateUser";
export const LOAD_AUTH = "loadUser";
export const CLEAR_AUTH = "clearState";

// mutation types
export const PURGE_AUTH = "logOut";
export const SET_USER = "setUser";
export const SET_AUTH = "setAuth";
export const SET_ERROR = "setError";
export const CLEAR_ERRORS = "clearErrors";

const state = {
  errors: null,
  user: {},
  tokens: {},
  isAuthenticated: !!JwtService.getTokens()
};

const getters = {
  currentUser(state) {
    return state.user;
  },
  isAuthenticated(state) {
    return state.isAuthenticated;
  }
};

const actions = {
  [LOGIN](context, credentials) {
    var section = context.rootState.config.section;
    var url = section === "default" ? "auth/access" : section + "/auth/access";

    return new Promise((resolve, reject) => {
      ApiService.post(url, credentials)
        .then(({ data }) => {
          context.commit(SET_AUTH, {
            section: section,
            tokens: data,
            isLogin: true
          });
          resolve(data);
        })
        .catch(({ response }) => {
          // context.commit(SET_ERROR, response.data.errors);
          if (response) {
            if (response.data.errors) {
              context.commit(SET_ERROR, response.data.errors);
            } else if (response.data.message) {
              // console.log(response);
              if ([401, 403].indexOf(response.status) !== -1) {
                context.commit(SET_ERROR, [
                  "Authentication Error! please try again"
                ]);
              } else {
                context.commit(SET_ERROR, [response.data.message]);
              }
            } else {
              context.commit(SET_ERROR, [
                "Server Error Occured: " + response.statusText
              ]);
            }
          } else {
            context.commit(SET_ERROR, ["An unknown Error Occured"]);
          }

          reject(response);
        });
    });
  },
  [LOGOUT](context) {
    const section = context.rootState.config.section;
    var url = section === "default" ? "auth/logout" : section + "/auth/logout";

    return new Promise((resolve, reject) => {
      ApiService.post(url)
        .then(({ data }) => {
          // console.log(data);
          context.commit(PURGE_AUTH, section);
          resolve(data);
        })
        .catch(error => {
          // console.log(error);
          if ([401, 403, 500, 502].indexOf(error.response.status) !== -1) {
            context.commit(SET_ERROR, ["Logout Failed!"]);
            context.commit(PURGE_AUTH, section);
          }

          reject(error);
        });
    });
  },
  [CLEAR_AUTH](context) {
    const section = context.rootState.config.section;
    context.commit(PURGE_AUTH, section);
  },
  [CLEAR_ERRORS](context) {
    context.commit(SET_ERROR, null);
  },
  [REGISTER](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(payload.url, payload.data)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          if (response.status && response.status == 422) {
            context.commit(SET_ERROR, {
              type: "validation",
              errors: response.data.errors
            });
          } else {
            var msg = null;
            if (response.data && response.data.message) {
              msg = response.data.message;
            } else {
              msg = "An unknown error occured, please try again later";
            }

            context.commit(SET_ERROR, [msg]);
          }

          reject(response);
        });
    });
  },
  [VERIFY_AUTH](context) {
    const section = context.rootState.config.section;
    const tokens = JwtService.getTokens(section, false);
    const url = section === "default" ? "profile" : section + "/profile";
    const user = context.state.user;

    if (tokens) {
      if (!user.id) {
        // ApiService.setHeader(section);
        ApiService.get(url)
          .then(({ data }) => {
            context.commit(SET_USER, {
              user: data.data,
              tokens: tokens
            });
            // console.log(tokens);
          })
          .catch(({ response }) => {
            if (response) {
              if (response.data.message) {
                context.commit(SET_ERROR, [response.data.message]);
              } else {
                context.commit(SET_ERROR, response.data.errors);
              }

              if ([401, 403].indexOf(response.status) !== -1) {
                context.commit(PURGE_AUTH, section);
              }
            } else {
              context.commit(SET_ERROR, ["Unkown Error Occured"]);
            }
          });
      }
    } else {
      context.commit(PURGE_AUTH, context.rootState.config.section);
    }
  },
  [UPDATE_USER](context, payload) {
    const { email, username, password, image, bio } = payload;
    const user = { email, username, bio, image };
    if (password) {
      user.password = password;
    }

    return ApiService.put("user", user).then(({ data }) => {
      context.commit(SET_AUTH, data);
      return data;
    });
  },
  [LOAD_AUTH](context) {
    var section = context.rootState.config.section;

    context.commit(LOAD_AUTH, JwtService.getTokens(section));
  },
  [SET_AUTH](context, tokens) {
    var section = context.rootState.config.section;

    context.commit(SET_AUTH, {
      section: section,
      tokens: tokens,
      isLogin: true
    });
  }
};

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [SET_AUTH](state, payload) {
    if (payload.isLogin) {
      state.isAuthenticated = true;
    }

    state.tokens = payload.tokens;
    state.errors = null;
    JwtService.saveTokens(payload.section, payload.tokens);
  },
  [SET_USER](state, payload) {
    // const section = state.context.rootState.config.section;

    state.isAuthenticated = true;
    state.user = payload.user;
    state.tokens = payload.tokens;
    state.errors = {};
    // JwtService.saveToken(state.user.token);
  },
  [PURGE_AUTH](state, section) {
    state.isAuthenticated = false;
    state.user = {};
    state.tokens = {};
    state.errors = null;
    JwtService.destroyToken(section);
  },
  [LOAD_AUTH](state, tokens) {
    state.isAuthenticated = !!tokens;
    state.tokens = tokens;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
